import { get } from './fetch'

export const getCountries = () => {
  return get(`settings/countries`)
}

export const getStates = (country) => {
  return get(`setting/states?country=${country}`)
}
